import React from 'react';
import CONSTANTS from '../../../assets/constants';
import { Link } from 'react-router-dom';
import ROUTES from '../../../routes';
import clockIcon from '../../../assets/Images/clockIcon.png';

const BeginActivity = () => (
  <div className="grid-container width-100 padding-vertical-3 padding-horizontal-2">
    <h2 className="padding-bottom-2">{CONSTANTS.WELCOME_TITLE}</h2>
    <p className="padding-bottom-2">{CONSTANTS.WELCOME_TEXT}</p>
    <div className="grid-x align-middle">
      <div className="cell small-12 medium-4 text-left">
        <Link
          className="button secondary rounded white-color margin-0"
          to={ROUTES.ACTIVITY}
        >
          {CONSTANTS.BEGIN_ACTIVITY_BUTTON}
        </Link>
      </div>
      <div className="cell small-12 medium-8 text-left">
        <div className="flex align-middle justify-center">
          <img className="padding-horizontal-1" src={clockIcon} alt="" />
          <span>{CONSTANTS.BEGIN_ACTIVITY_NOTE}</span>
          <span className="font-bold"> {CONSTANTS.BEGIN_ACTIVITY_TIME}</span>
        </div>
      </div>
    </div>
    <div className="grid-x align-left" />
  </div>
);

export default BeginActivity;
